module.exports = __webpack_public_path__ + "img/couples-067.ada68b89.jpg";